export const PATH = {
  CAMPAIGN_POINTS: "/campaign_points",
};
